import InnerHeader from "../../components/InnerHeader";
import "./ewallet.css";
import { ChevronLeft } from "lucide-react";

import { useNavigate } from "react-router-dom";
export default function EWallet() {
  const navigate = useNavigate();
  return (
    <div className="ewallet-page">
      {/* Header */}
      {/* <div className="ewallet-header">
        <ChevronLeft className="back-icon" />
        <span>E-wallet</span>
      </div> */}
      <InnerHeader title="E-wallet" />
      {/* Title */}
      <div className="ewallet-title">Select payment</div>

      {/* Wallet Grid */}
      <div className="wallet-grid">
        {/* Active */}
        <div onClick={() => navigate("/withdrawal-entry")} className="wallet-card active">
          <div className="wallet-icon bkash">bK</div>
          <span>bKash</span>
        </div>

        <div onClick={() => navigate("/withdrawal-entry")} className="wallet-card active">
          <div className="wallet-icon nagad">N</div>
          <span>Nagad</span>
        </div>

        {/* Inactive */}
        <div onClick={() => navigate("/withdrawal-entry")} className="wallet-card inactive">
          <div className="wallet-icon rocket">R</div>
          <span>Rocket</span>
          <small>Inactive</small>
        </div>

        <div onClick={() => navigate("/withdrawal-entry")} className="wallet-card inactive">
          <div className="wallet-icon upay">U</div>
          <span>Upay</span>
          <small>Inactive</small>
        </div>
      </div>
    </div>
  );
}
